<div class="animated fadeIn">
<h3>Analyst Panel</h3>
                <br/>

<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
             <h4 class="box-title">View File Details</h4>
             <a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="backfile()">Back</a>
              <br/>
              <h4 class="box-title">{{fileHead}}</h4>
              <ul id="sheetCont">
                   <li [ngClass]="(sheetIndex==i)?'btn btn-info':'btn btn-primary'" style="float: left;margin-right: 5px;"  *ngFor="let item of tabDetails; let i = index" (click)="gotoFile(fileId,i)">
                        <a  style="color:#000 !important;">{{item}}</a> 
                    </li>
               </ul>
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info" >
                                            <!--<thead>
                                                <tr role="row">
                                                    <th >Name</th>
                                                    <th >Year</th>
                                                    <th >Quarter</th>
                                                    <th>Month</th>
                                                    <th>Type</th>
                                                    <th>Status</th>
                                                   <th>Action</th>
                                                </tr>
                                            </thead>-->
                                            <tbody [innerHTML]="safeHtml">
                                          <!--  <tr role="row" class="odd" >
                                                <td ></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Uploaded</td>
                                               <td></td>
                                            </tr> 
                                            
                                            -->
                                        
                                        </tbody>
                                        </table>
            </div>
        </div>
       

</div>
</div><!-- .animated -->

